/**
 * @description: classnames
 * @param {*} classMap class的map
 * @return {*} class string
 */
export function classNames(classMap) {
    let hook = []
    for (let k in classMap) {
        if (Object.prototype.hasOwnProperty.call(classMap, k)) {
            if (classMap[k]) {
                hook.push(k)
            }
        }
    }
    return hook.join(' ')
}




/**
 * @description: 获取唯一id
 * @param {*} len 长度
 * @param {*} radix 基数
 * @return {*} 唯一id
 */
export function uuid(len = 8, radix = 10) {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    let uuid = [], i;
    radix = radix || chars.length;
    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }
    return uuid.join('');
}

export function getParam(keyName) {
    const urls = new URL(window.location.href)
    return urls.searchParams.get(keyName)
}

/**
 * @description: 最小值、首选值、最大值的限制区间
 * @param {*} min
 * @param {*} val
 * @param {*} max
 * @return {*}
 */
export function clamp(min, val, max) {
    return Math.max(min, Math.min(val, max))
}

/**
 * @description: 判断是否为空对象
 * @param {*} obj
 * @return {*} true or false
 */
export function isEmptyObject(obj) {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return false
    return !Object.keys(obj).length
}


/**
 * @description: 获取数组嵌套对象数组的深度
 * @param {*} options 数据源
 * @return {*} number 深度值
 */
export function getMaxColumns(options) {
    let hooks = []
    let res = []
    function loop(arr) {
        arr.forEach((el, index) => {
            if (typeof hooks[index] === 'undefined') {
                hooks[index] = 0
            }
            if (el.children && el.children.length > 0) {
                hooks[index] = hooks[index] + 1
                loop(el.children)
            }
        })
    }
    loop(options)
    return Math.max.apply(null, hooks)
}



/**
 * @description: 获取选中的一条tree数组
 * @param {*} options
 * @param {*} index
 * @return {*}
 */
export function getColmnsInit(options, index = 0) {
    let hooks = []
    let i = 0;
    function a(arr) {
        if (typeof hooks[i] === 'undefined') {
            hooks[i] = []
        }
        hooks[i] = arr
        for (let j = 0; j < arr.length; j++) {
            let el = arr[j]
            if (el.children && el.children.length > 0 && index === j) {
                i++;
                a(el.children)
            } else {
                break
            }
        }
    }
    a(options)
    return hooks
}

/**
 * @description: 返回tree的选中链接数组
 * @param {*} options
 * @return {*}
 */
export function getColumnsData(options) {
    const len = getMaxColumns(options);
    let init = getColmnsInit(options)
    const arr = []
    for (let i = 0; i <= len; i++) {
        arr.push({
            items: init[i] ? init[i] : [],
            id: uuid(),
            defaultValue: init[i] ? init[i][0].value : ''
        })
    }
    return arr
}


export function dispatch(node,eventName,detail){
    node.dispatchEvent(new CustomEvent(eventName, {
        detail,
        bubbles: true,
        cancelable: true,
        composed: true
    }));
}

/**
 * @description: 是否在可视区内
 * @param {*} el
 * @return {*}
 */
export function inViewport(node, options = {}) {
    if(!options.lazy) return
    const isSupport = 'IntersectionObserver' in window;
    if(!isSupport){
        dispatch(node,'enter', { inView:true })
        return
    }
    const opts = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }
    let inView = false;

    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                const { isIntersecting, intersectionRatio } = entry || {}
                inView = isIntersecting
                dispatch(node,'change', { inView, entry, intersectionRatio })
                if(inView){
                    dispatch(node,'enter', { inView, entry, intersectionRatio })
                    if(options.unobserveOnEnter){
                        observer.unobserve(node)
                    }
                }else{
                    dispatch(node,'leave', { inView, entry, intersectionRatio })
                }
            }
        },
        {
            ...opts,
            ...options
        },
    );
    observer.observe(node);
    return {
        destroy() {
            observer.unobserve(node);
        },
    };
}